import { render, staticRenderFns } from "./DiscountPage.vue?vue&type=template&id=f0116c5a&scoped=true"
import script from "./DiscountPage.vue?vue&type=script&lang=js"
export * from "./DiscountPage.vue?vue&type=script&lang=js"
import style0 from "./DiscountPage.vue?vue&type=style&index=0&id=f0116c5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0116c5a",
  null
  
)

export default component.exports